var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._l(_vm.fields, function (field, i) {
      return _c("div", { key: i, staticClass: "field-container label-value" }, [
        _c("div", { staticClass: "label-container" }, [
          _c("div", { staticClass: "label-field" }, [
            _vm._v(" " + _vm._s(field.text) + " "),
          ]),
          _c("div", { staticClass: "label-field-value" }, [
            _vm._v(" " + _vm._s(field.value) + " "),
          ]),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }